<template>
  <div v-loading="loading"
       element-loading-text="拼命加载中...">
    <div class="content-box">

      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in systemList"
                     :key="item.sys"
                     :label="systemCode[item.sys]">
          <el-tree @check="handleCheck"
                   :data="item.treeList"
                   show-checkbox
                   :default-checked-keys="checkListObj[item.sys].checkList"
                   :default-expanded-keys="checkListObj[item.sys].checkList"
                   node-key="id"
                   :ref="item.sys"
                   highlight-current
                   :props="defaultProps">
          </el-tree>
        </el-tab-pane>
      </el-tabs>
      <!-- 截止------- -->
      <!-- <div class="tab-con"
           v-for="item in systemList"
           :key="item.sys">
        <div class="authority-table-header">
          <div class="authority-table-header-title">{{systemCode[item.sys]}}</div>
          <el-checkbox v-model="item.checkedAll"
                       @change="handleCheckedAll(item)">全部选中</el-checkbox>
        </div>
        <el-tree @check="handleCheck"
                 :data="item.treeList"
                 show-checkbox
                 :default-checked-keys="checkListObj[item.sys].checkList"
                 :default-expanded-keys="checkListObj[item.sys].checkList"
                 node-key="id"
                 :ref="item.sys"
                 highlight-current
                 :props="defaultProps">
        </el-tree>
      </div> -->
    </div>
    <div style="display:flex;justify-content:center;height: 45px;padding: 15px 0;">
      <el-button type="primary"
                 @click="handleSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import { systemAuthority, saveAuthority, SYSTEM_CODE } from '@/api/analyse.js'
export default {
  name: 'rule-setNew',
  data () {
    return {
      activeName: '0',
      loading: false, // 加载
      expandedKeys: [], // 展开的节点
      checkedKeys: [], // 选中的节点
      activeNames: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      systemList: [],
      systemCode: SYSTEM_CODE,
      appPermDataList: [],
      checkListObj: {
        'CLOUD_SHOP': {
          checkList: [], // 回显上次选中的叶子节点
          idList: [] // 所有叶子节点的id的长度
        },
        'ZY_MARKET': {
          checkList: [],
          idList: []
        },
        'ZY_INTELLIQUOR': {
          checkList: [],
          idList: []
        },
        'ZY_MEMBER': {
          checkList: [],
          idList: []
        },
        'ZY_GROUP': {
          checkList: [],
          idList: []
        },
        // 云商
        'CLOUD_BUSINESS': {
          checkList: [],
          idList: []
        },
        // 云销
        'CLOUD_MARKET': {
          checkList: [],
          idList: []
        },
        'SAVOUR_WINE': {
          checkList: [],
          idList: []
        },
        'BIG_SCREEN':{
          checkList: [],
          idList: []
        },
        'TERMINAL_MGR':{
          checkList: [],
          idList: []
        },
        'BG_TASK_RELEASE':{
          checkList: [],
          idList: []
        },
        'DRINK_ADVISORY':{
          checkList: [],
          idList: []
        },
        'SEALALTAR':{
          checkList: [],
          idList: []
        }
      }, // 存选中的id集合的对象
      isAllChecked: false // 是否全部选中
    }
  },
  mounted () {
    this.loading = true
    this.getSystemAuthority()
  },
  methods: {
    handleCheck (data, check) {
      const { systemCode } = data.attributes
      const systemCodeList = this.appPermDataList.map(ele => ele.systemCode)
      const idList = [...check.checkedKeys, ...check.halfCheckedKeys]

      if (this.appPermDataList.length === 0) {
        this.appPermDataList.push({
          perms: [...check.checkedKeys, ...check.halfCheckedKeys],
          systemCode
        })
      }

      // 当点击了其他项目下的树时
      const obj = this.appPermDataList.find(item => item.systemCode === systemCode)
      if (obj) {
        obj.perms = idList
      } else {
        this.appPermDataList.push({
          perms: [...check.checkedKeys, ...check.halfCheckedKeys],
          systemCode
        })
      }

      // 当这颗树没有选中节点时，把这颗树从this.appPermDataList移除
      if (idList.length === 0) {
        this.appPermDataList = this.appPermDataList.filter(item => item.systemCode !== systemCode)
      }

      // 选中状态的切换
      this.handleIsAllChecked(idList, systemCode)
    },

    // 是否全部选中  选中状态的切换
    handleIsAllChecked (idList, systemCode) {
      const len = this.checkListObj[systemCode].idList.length
      this.systemList.forEach(item => {
        if (item.sys === systemCode) {
          item.checkedAll = idList.length === len
        }
      })
    },
    // 获取权限
    async getSystemAuthority () {
      const companyId = this.$route.query.id
      const result = await systemAuthority(companyId)
      const { code, result: res = [], message } = result.data || {}
      if (code === '200') {
        res.forEach(items => {
          // 获取每棵树上所有的id
          this.getTreeId(items.treeList)
          // 回显上次选中的
          items.treeList.forEach(item => {
            if (item.state.selected && item.children.length === 0) {
              this.checkListObj[items.sys].checkList.push(item.id)
            }
            if (item.children) {
              this.childTree(item.children)
            }
          })
          // 判断是不是全部选中了  items.perms里面是所有选中的叶子节点的id
          const checkedIdLen = items.perms.length
          const idListLen = this.checkListObj[items.sys].idList.length
          items.checkedAll = checkedIdLen === idListLen
          // 把已经选中的加入到入参appPermDataList中
          if (items.perms.length > 0) {
            this.appPermDataList.push({
              systemCode: items.sys,
              perms: items.perms
            })
          }
        })

        this.systemList = res
        this.loading = false
      } else {
        _g.toastMsg('error', message)
        this.loading = false
      }
    },

    // 拿选中的最里层的叶子节点id
    childTree (children) {
      for (let item of children) {
        if (item.state.selected && item.children.length === 0) {
          this.checkListObj[item.attributes.systemCode].checkList.push(item.id)
        }
        if (item.children) {
          this.childTree(item.children)
        }
      }
    },
    // 获得所有树节点id
    getTreeId (treeList) {
      treeList.forEach(item => {
        this.checkListObj[item.attributes.systemCode].idList.push(item.id)
        this.handleTreeId(item)
      })
    },

    // 递归拿所有叶子节点的id
    handleTreeId (node) {
      node.children.forEach((item) => {
        this.checkListObj[item.attributes.systemCode].idList.push(item.id)
        this.handleTreeId(item)
      })

      if (!node.children) {
        this.checkListObj[item.attributes.systemCode].idList.push(node.id)
      }
    },
    // 全部选中
    handleCheckedAll (item) {
      const { sys: systemCode } = item
      // 判断一下 全部选中按钮是否选中了，选中状态下 拿到每个treeList的id
      this.checkedKeys = item.checkedAll ? item.treeList.map(ele => ele.id) : []
      // 讲拿到的treeList的id数组设置为选中
      item.treeList.forEach((ele, index) => {
        this.$refs[item.sys][index].setCheckedKeys(this.checkedKeys)
      })
      if (item.checkedAll) {
        //  this.perms里面放全部选中之后所有的id
        const systemCodeList = this.appPermDataList.map(item => item.systemCode)

        // 如果appPermDataList的长度为0或者从未选中过这颗树 => 往appPermDataList里面加信息
        if (this.appPermDataList.length === 0 || !systemCodeList.includes(systemCode)) {
          this.appPermDataList.push({
            perms: this.checkListObj[systemCode].idList,
            systemCode
          })
        }
        // 如果这颗树的信息已经存在了，全选之后把这棵树上所有的id都放进去
        if (systemCodeList.includes(systemCode)) {
          const obj = this.appPermDataList.find(item => item.systemCode === systemCode)
          if (obj) {
            obj.perms = this.checkListObj[systemCode].idList
          }
        }
      } else {
        this.appPermDataList = this.appPermDataList.filter(ele => ele.systemCode !== systemCode)
      }
    },

    // 全部展开
    handleExpandedAll (item) { },

    // 保存
    async handleSave () {
      const { appPermDataList: list } = this
      const data = {
        roleId: this.$route.query.id || '',
        appPermDataList: list
      }
      const result = await saveAuthority(this.$route.query.id, JSON.stringify(data))
      const { code, message } = result.data || {}
      if (code === '200') {
        _g.toastMsg('success', message)
        // this.getSystemAuthority()
        setTimeout(() => {
          this.$router.go(-1)
        }, 1000)
      } else {
        _g.toastMsg('error', message)
      }
    }
  }
}
</script>

<style scoped>
.authority {
  display: flex;
  justify-content: space-between;
  height: 30px;
  margin-bottom: 10px;
}

.authority-table-header {
  display: flex;
  align-items: center;
  background-color: #e8f2fb;
  height: 50px;
}
.authority-table-header-title {
  font-weight: bold;
  font-size: 20px;
  margin: 0 20px;
}
.content-box {
  padding: 15px 30px;
  margin: 20px;
  background-color: #ffffff;
  min-height: 500px;
  overflow: hidden;
}
</style>
